// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3xJFd","header":"Messages_header__33doM"};